module.exports = __webpack_public_path__ + "static/valtra-480x480-13c0284f11e3d7b10cc0197b99237e76.png";